<template>
    <div :id="rootElementId">
        <center>
            <canvas :id="canvasElementId"
            :class="`${visualization === 'heatMap' ? 'canvas_heat_map' : ''} ${currentUserFieldColor}_pitch`"></canvas>
        </center>
    </div>
</template>

<script>
import {color} from 'd3-color';
import {extent} from 'd3-array';
import {voronoi} from 'd3-voronoi';
import {arc, line, symbol, symbolTriangle, symbolCross} from 'd3-shape';
import {scaleLinear} from 'd3-scale';
import {select} from 'd3-selection';
import * as simpleheat from '../../utils/simpleheat';
import UserService from '../../services/user.service';
import {getPositionGroupComplete} from '../../utils/functions';

  export default {
    name: 'EventsChart',
    components:{
    },
    computed:{
        currentUserLanguage() {
            return this.$store.getters["auth/language"];
        },
        currentUserFieldColor() {
            return this.$store.getters["auth/fieldColor"];
        },
        rootElementId(){
            return `pitchEvents${this.id}`
        },
        canvasElementId(){
            return `pitchEvents${this.id}Canvas`
        },
        dpr(){
            return 2;
        },
        chartSize(){
            return this.size > 1140 ? 1140 : this.size;
        },
        chartRate(){
            return this.chartSize / 1140;
        },
        CANVASWIDTH(){
            return this.chartSize * this.dpr;
        },
        CANVASHEIGHT(){
            return this.chartSize / 1.5 * this.dpr;
        },
        labelFamily(){
            return this.fontFamily;
        },
        margins(){
            return {
                top: (this.vertical ? 0.087 : 0.087 * 1.7) * this.CANVASHEIGHT,
                bottom: 0.086 * this.CANVASHEIGHT,
                left: 0.084 * this.CANVASWIDTH,
                rigth: 0.079 * this.CANVASWIDTH
            }
        },
        WIDTH(){
            return this.CANVASWIDTH - this.margins.left - this.margins.rigth
        },
        HEIGHT(){
            return this.CANVASHEIGHT - this.margins.top - this.margins.bottom
        },
        lastSearchId() {
            return this.$store.state.auth.lastSearch;
        },
        STATS_TO_SHOW(){
            let group = getPositionGroupComplete(this.player.fieldPositionId);
            switch(group){
                case "defenders":
                    return [
                        {isDetailed: true,text:this.$t("statsNaming.Passes"),statCode:'passes',statDetailCode:'passesSuccessful'},
                        {isDetailed: true,text:this.$t("statsNaming.TacklesSuccessful"),statCode:'tackles',statDetailCode:'tacklesSuccessful'},
                        {text:this.$t("statsNaming.Aerials"),statCode:'aerialsTotal'},
                        {text:this.$t("statsNaming.Clearances"),statCode:'clearances'},
                        {text:this.$t("statsNaming.Dispossessed"),statCode:'dispossessed'},
                        {text:this.$t("statsNaming.Fouls"),statCode:'fouls'},
                        {text:this.$t("statsNaming.Interceptions"),statCode:'interceptions'}
                    ]
                    break;
                case "fullbacks":
                    return [
                        {isDetailed: true,text:this.$t("statsNaming.Passes"),statCode:'passes',statDetailCode:'passesSuccessful'},
                        {text:this.$t("statsNaming.CompletedCrosses"),statCode:'completedCrosses'},
                        {isDetailed: true,text:this.$t("statsNaming.TacklesSuccessful"),statCode:'tackles',statDetailCode:'tacklesSuccessful'},
                        {text:this.$t("statsNaming.Fouls"),statCode:'fouls'},
                        {text:this.$t("statsNaming.Dispossessed"),statCode:'dispossessed'},
                        {text:this.$t("statsNaming.Recoveries"),statCode:'recoveries'},
                        {text:this.$t("statsNaming.Clearances"),statCode:'clearances'},
                        {text:this.$t("statsNaming.Aerials"),statCode:'aerialsTotal'},
                    ]
                    break;
                case "midfielders":
                    return [
                        {isDetailed: true,text:this.$t("statsNaming.Passes"),statCode:'passes',statDetailCode:'passesSuccessful'},
                        {text:this.$t("statsNaming.Dispossessed"),statCode:'dispossessed'},
                        {isDetailed: true,text:this.$t("statsNaming.TacklesSuccessful"),statCode:'tackles',statDetailCode:'tacklesSuccessful'},
                        {text:this.$t("statsNaming.Recoveries"),statCode:'recoveries'},
                        {text:this.$t("statsNaming.FoulsTaken"),statCode:'foulsTaken'},
                        {text:this.$t("statsNaming.OpenPlayKeyPasses"),statCode:'keyPasses'},
                        {text:this.$t("statsNaming.Aerials"),statCode:'aerialsTotal'},
                        {text:this.$t("statsNaming.LongBallSuccessful"),statCode:'longPasses'},
                        {text:this.$t("statsNaming.xAssists"),statCode:'xA'},
                        {text:this.$t("statsNaming.xT"),statCode:'xT'}
                    ]
                    break;
                case "wingers":
                    return [
                        {isDetailed: true,text:this.$t("statsNaming.Passes"),statCode:'passes',statDetailCode:'passesSuccessful'},
                        {isDetailed: true,text:this.$t("playerScout.dribbles"),statCode:'dribbles',statDetailCode:'dribblesSuccessful'},
                        {text:this.$t("statsNaming.Shots"),statCode:'shotsTotal'},
                        {text:this.$t("statsNaming.FoulsTaken"),statCode:'foulsTaken'},
                        {text:this.$t("statsNaming.OpenPlayPassesIntoOpponentBox"),statCode:'passesIntoOppBox'},
                        {text:this.$t("statsNaming.OpenPlayKeyPasses"),statCode:'keyPasses'},
                        {text:this.$t("statsNaming.NonPenaltyGoals"),statCode:'npg'},
                        {text:this.$t("statsNaming.xT"),statCode:'xT'},
                        {text:this.$t("statsNaming.xG"),statCode:'xG'},
                        {text:this.$t("statsNaming.xAssists"),statCode:'xA'}
                    ]
                    break;
                case "forwards":
                    return [
                        {isDetailed: true,text:this.$t("statsNaming.Passes"),statCode:'passes',statDetailCode:'passesSuccessful'},
                        {text:this.$t("statsNaming.Shots"),statCode:'shotsTotal'},
                        {text:this.$t("statsNaming.FoulsTaken"),statCode:'foulsTaken'},
                        {text:this.$t("statsNaming.OpenPlayPassesIntoOpponentBox"),statCode:'passesIntoOppBox'},
                        {text:this.$t("statsNaming.OpenPlayKeyPasses"),statCode:'keyPasses'},
                        {text:this.$t("statsNaming.NonPenaltyGoals"),statCode:'npg'},
                        {text:this.$t("statsNaming.xG"),statCode:'xG'},
                        {text:this.$t("statsNaming.xAssists"),statCode:'xA'}
                    ]
                    break;
            }
            return [];
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        events:{
            type: Array,
            required: false
        },
        size: {
            type: Number,
            required: true
        },
        chartTypeModel: {
            type: Array,
            default: () => {
                return ['circles']
            }
        },
        vertical:{
            type: Boolean,
            default: false
        },
        visualization: {
            type:String,
            default: 'basic'
        },
        player: {
            type:Object,
            required: false
        },
        stats: {
            type:Object,
            required: false
        },
        fontFamily:{
            type: String,
            default: 'NeueMontreal'
        },
        embed:{
            type: Boolean,
            default: false
        }
    },
    created(){
      //When window resize

      window.addEventListener("resize", this.onWindowResize);
    },
    async mounted(){
        this.observer = new ResizeObserver(this.onResize).observe(document.getElementById(this.rootElementId));
        if(this.visualization === 'basic'){
            await this.renderEventsMap();
        }else{
            await this.renderHeatMap();
        }
        UserService.putLastSearchRendered({id:this.lastSearchId});
    },
    data() {
      return {
          observer: null
      }
    },
    watch: {
    },
    methods:{
        onWindowResize(){

        },
        async renderEventsMap(){
            let canvas = document.getElementById(this.canvasElementId);
            let chartWrapper = document.getElementById(this.rootElementId);
            canvas.width = this.CANVASWIDTH;
            canvas.height = this.CANVASHEIGHT;
            canvas.style.width = (this.CANVASWIDTH / this.dpr) + "px";
            canvas.style.height = (this.CANVASHEIGHT / this.dpr) + "px";
            let context = canvas.getContext('2d');


            await this.drawPitch(context,canvas,require(`@/assets/img/pitch_${this.currentUserFieldColor}_wide.png`))

            context.save();
            context.translate(this.margins.left, this.margins.top);
            if (this.chartTypeModel.includes("circles")) {

                // Render normal carries
                if (this.vertical) {
                    this.renderVerticalCircles(context, this.events.filter(e => e.e === "Carries" && e.e !== "Assist" && e.e !== "Goal" && e.e !== "KeyPass" && e.e !== "Shot"));
                    this.renderVerticalSegments(context, this.events.filter(e => e.e === "Carries" && e.e !== "Assist" && e.e !== "Goal" && e.e !== "KeyPass" && e.e !== "Shot"), "#FFFFFF");
                } else {
                    this.renderCircles(context, this.events.filter(e => e.e === "Carries" && e.e !== "Assist" && e.e !== "Goal" && e.e !== "KeyPass" && e.e !== "Shot"));
                    this.renderSegments(context, this.events.filter(e => e.e === "Carries" && e.e !== "Assist" && e.e !== "Goal" && e.e !== "KeyPass" && e.e !== "Shot"), "#FFFFFF");
                }

                // Render everthing except carries
                if (this.vertical) {
                    this.renderVerticalCircles(context, this.events.filter(e => e.e !== "Carries"));
                    this.renderVerticalSegments(context, this.events.filter(s => s.e === 'Pass' || s.e === "Goal" || s.e === "ChanceMissed" || s.e.includes ("Shot") || s.e.includes ("OffsidePass") || s.e === "BallProgression"), "#FFFFFF");
                } else {
                    this.renderCircles(context, this.events.filter(e => e.e !== "Carries"));
                    this.renderSegments(context, this.events.filter(s => s.e === 'Pass' || s.e === "Goal" || s.e === "ChanceMissed" || s.e.includes ("Shot") || s.e.includes ("OffsidePass") || s.e === "BallProgression"), "#FFFFFF");
                }

                // Render carries over the rest
                if (this.vertical) {
                    this.renderVerticalCircles(context, this.events.filter(e => e.e === "Carries" && (e.e === "Assist" || e.e === "Goal" || e.e === "KeyPass" || e.e === "Shot")));
                    this.renderVerticalSegments(context, this.events.filter(e => e.e === "Carries" && (e.e === "Assist" || e.e === "Goal" || e.e === "KeyPass" || e.e === "Shot")), "#FFFFFF");
                } else {
                    this.renderCircles(context, this.events.filter(e => e.e === "Carries" && (e.e === "Assist" || e.e === "Goal" || e.e === "KeyPass" || e.e === "Shot")));
                    this.renderSegments(context, this.events.filter(e => e.e === "Carries" && (e.e === "Assist" || e.e === "Goal" || e.e === "KeyPass" || e.e === "Shot")), "#FFFFFF");
                }

            }

            context.restore();

            this.renderLegend(
                context,
                this.events.filter(e => e.e !== "Pass" && e.e !== "Carries" && e.e !== "OffsidePass" && e.e !== "BallProgression").length > 0,
                this.events.filter(e => e.e === "Pass" || e.e === "OffsidePass").length > 0,
                this.events.filter(e => e.e === "Carries").length > 0,
                this.events.filter(e => e.e === "BallProgression").length > 0
            );



            if (this.chartTypeModel.includes("boxes"))
                this.renderBoxes(context, this.vertical ? this.events.filter(s => s.x >= 50) : this.events, this.vertical);

            if(this.events && this.events.length){
                this.renderPlayerPrompt(context,this.events[0].player)
            }

            this.renderDirectionOfPlay(context);
            this.renderLogo(context);

            const tooltip = d3
                .select("body")
                .append("div")
                .attr("display", "none")
                .attr("class", "tooltip-no-arrow");

            let voronoiDiagram = this.computeVoronoi(this.events, this.vertical === true ? 'verticalPitch' : 'fullPitch');
            this.handleMouseEnter(canvas, voronoiDiagram, tooltip, true);

            this.renderStats(context);
        },
        renderVerticalCircles(context, circles) {
            let x = scaleLinear().domain([0, 100]).range([this.WIDTH, 0]);
            let y = scaleLinear().domain([0, 100]).range([this.HEIGHT, 0]);
            let radius = scaleLinear().domain([0, 1]).range([6 * this.dpr * this.chartRate, 24 * this.dpr * this.chartRate]);

            // ====================================================================
            //        Render Events
            // ====================================================================

            for (let circle of circles) {
                let sx = 0;
                let sy = 0;
                if (circle.e !== "Carries" && circle.e !== "BallProgression") {
                    if (circle.isHomeTeam)
                    sx = circle.e === "Pass" || circle.e === "OffsidePass" || circle.e === "Goal" || circle.e === "MissedChance" || circle.e.includes("Shot") ? x(circle.y_end) : x(circle.y);
                    sy = circle.e === "Pass" || circle.e === "OffsidePass" || circle.e === "Goal" || circle.e === "MissedChance" || circle.e.includes("Shot") ? y(100 - (100 - circle.x_end) * 2) : y(100 - (100 - circle.x) * 2);
                    if (circle.o === false || circle.e === "MissedChance" || circle.e.includes("Shot") || circle.e === "OffsidePass")
                        this.drawCross(context, x(circle.y), y(100 - (100 - circle.x) * 2), 90, '#FF0000');
                    else
                        this.drawCircle(context, x(circle.y), y(100 - (100 - circle.x) * 2), 6, 0.3, '#FFFFFF', '#28e628');
                    if (circle.e === "Pass" || circle.e === "OffsidePass" || circle.e === "Goal" || circle.e.includes("Shot")) {
                        this.drawTriangle(context, x(circle.y), y(100 - (100 - circle.x) * 2), sx, sy, 45, (circle.o === false || circle.e === "MissedChance" || circle.e.includes("Shot") || circle.e === "OffsidePass" ? '#FF0000' : '#28e628'));
                    }
                } else {
                    let colorOfcarries = this.getColorOfCarries(circle);
                    sx = x(circle.y);
                    sy = y(100 - (100 - circle.x) * 2);
                    this.drawCircle(context, sx, sy, 7, circle.e === "Goal" || circle.e === "Assist" || (circle.e === "Event" && circle.o === true) ? 0.9 : 0.2, colorOfcarries, colorOfcarries);
                }
            }
        },
        drawCross(context, x, y, radius, strokeColor) {
            let triangle = symbol()
                .type(symbolCross)
                .size(radius * this.dpr)
                .context(context);

            context.lineWidth = this.dpr * this.chartRate;
            context.strokeStyle = strokeColor;
            context.fillStyle = strokeColor;

            context.save();
            context.translate(x, y);
            context.rotate(Math.PI / 4);
            context.beginPath();
            triangle();
            context.stroke();
            context.fill();
            context.restore();
        },
        drawCircle(context, x, y, radius, opacity, teamColor, strokeColor) {


            let circle = arc()
                .innerRadius(0)
                .outerRadius(radius * this.dpr)
                .startAngle(0)
                .endAngle(2 * Math.PI)
                .context(context);

            context.lineWidth = 2 * this.dpr * this.chartRate;
            context.strokeStyle = strokeColor;
            let c = color(teamColor);
            c.opacity = opacity;
            context.fillStyle = c.rgb();

            context.save();
            context.translate(x, y);
            context.beginPath();
            circle();
            context.stroke();
            context.fill();
            context.restore();
        },
        drawTriangle(context, x, y, xEnd, yEnd, radius, strokeColor) {
            let triangle = symbol()
                .type(symbolTriangle)
                .size(radius * this.dpr)
                .context(context);

            context.lineWidth = 2 * this.dpr * this.chartRate;
            context.strokeStyle = strokeColor;
            context.fillStyle = strokeColor;

            const angleRadians = Math.atan2(yEnd - y, xEnd - x);

            context.save();
            context.translate(xEnd, yEnd);
            context.rotate(angleRadians + (Math.PI / 2));
            context.beginPath();
            triangle();
            context.stroke();
            context.fill();
            context.restore();
        },
        getColorOfCarries(circle) {
            switch (circle.e) {
                case "Goal":
                case "Shot":
                return '#28e628';
                case "Assist":
                case "KeyPass":
                return '#1e1eff';
                default:
                return '#b3b7c6';
            }
        },
        renderVerticalSegments(context, segments, teamColor, widthDomain = null) {
            widthDomain = widthDomain !== null ? [0, 60] : extent(segments, c => c.width);

            let x = scaleLinear().domain([0, 100]).range([this.WIDTH, 0]);
            let y = scaleLinear().domain([0, 100]).range([this.HEIGHT, 0]);
            let width = scaleLinear().domain(widthDomain).range([1 * this.dpr * this.chartRate, 10 * this.dpr * this.chartRate]);

            // ====================================================================
            //        Render Segments
            // ====================================================================

            for (let segment of segments) {
                let sx0 = x(segment.y);
                let sy0 = y(100 -(100 - segment.x) * 2);
                let sx1 = x(segment.y_end);
                let sy1 = y(100 - (100 - segment.x_end) * 2);

                if (segment.e !== "Carries" && segment.e !== "BallProgression")
                    this.drawXALine(context, sx0, sy0, sx1, sy1, width(segment.width) * 1.5, segment.xA, (segment.o === false || segment.e === "MissedChance" || segment.e.includes("Shot") || segment.e === "OffsidePass" ? '#FF0000' : '#28e628'), 0.8);
                else{
                    //Here code for Carries and BallProgressions
                    sx0 = x(segment.pESY);
                    sy0 = y(100 -(100 - segment.pESX) * 2);
                    sx1 = x(segment.y);
                    sy1 = y(100 - (100 - segment.x) * 2);
                    let sx2 = x(segment.y_end);
                    let sy2 = y(100 - (100 - segment.x_end) * 2);

                    let colorOfCarries = this.getColorOfCarries(segment);
                    let angle = this.getAngle(sx0, sy0, sx1, sy1);
                    let sx1Carries = sx1 - Math.cos(angle) * 15;
                    let sy1Carries = sy1 - Math.sin(angle) * 15;

                    this.drawXALine(context, sx0, sy0, sx1Carries, sy1Carries, segment.result === "Event" ? width(segment.width) * 1.5 : width(segment.width) * 2, segment.xA, colorOfCarries, segment.result === "Event" ? 0.4 : 0.9);

                    if(segment.x != segment.x_end && segment.e === "BallProgression"){
                        let angle2 = this.getAngle(sx1, sy1, sx2, sy2);
                        sx1 = sx1 + Math.cos(angle2) * 15;
                        sy1 = sy1 + Math.sin(angle2) * 15;
                        //If x and x_end are different and is a BallProgression, then print next event (dashed) line
                        this.drawNextEventLine(context, sx1, sy1, sx2, sy2, segment.result === "Event" ? width(segment.width) * 1.5 : width(segment.width) * 2, segment.xA, colorOfCarries, segment.result === "Event" ? 0.4 : 0.9);
                        this.drawTriangle(context, sx1, sy1, sx2, sy2, 45, colorOfCarries);
                    }
                }
            }
        },
        drawXALine(context, x0, y0, x1, y1, width, xa, strokeColor = "black", opacity = 1) {
            let renderLine = line()
                .context(context);

            context.lineWidth = width * 2;
            context.lineCap = "round";
            let c = color(strokeColor);
            c.opacity = opacity;
            context.strokeStyle = c.rgb(); //lineargradient;

            context.beginPath();
            renderLine([
                [x0, y0],
                [x1, y1]
            ]);
            context.stroke();
        },
        getAngle(cx, cy, ex, ey) {
            var dy = ey - cy;
            var dx = ex - cx;
            return Math.atan2(dy, dx); // range (-PI, PI]
        },
        drawNextEventLine(context, x1, y1, x2, y2, width, xa, strokeColor, opacity) {
            let renderLine = line()
                .context(context);

            context.save();
            context.lineWidth = this.width * this.dpr;
            context.lineCap = "round";
            context.setLineDash([5, 15]);
            let c = color(strokeColor);
            c.opacity = opacity;
            context.strokeStyle = c.rgb(); //lineargradient;

            context.beginPath();
            renderLine([
                [x1, y1],
                [x2, y2]
            ]);
            context.stroke();
            context.restore();
        },
        renderCircles(context, circles) {
            let x = scaleLinear().domain([0, 100]).range([this.WIDTH, 0]);
            let y = scaleLinear().domain([0, 100]).range([this.HEIGHT, 0]);
            let radius = scaleLinear().domain([0, 1]).range([6 * this.dpr * this.chartRate, 24 * this.dpr * this.chartRate]);
            let radiusScalePasses = d3.scale.linear().domain([0, 1]).range([this.chartSize * 0.0055, this.chartSize * 0.024]);
            let radiusPasses = radiusScalePasses(0.02);
            let radiusEvents = radiusScalePasses(0.125);

            // ====================================================================
            //        Render Events
            // ====================================================================
            for (let circle of circles) {
                let sx = 0;
                let sy = 0;
                if (circle.e !== "Carries" && circle.e !== "BallProgression") {
                    if (circle.isHomeTeam) {
                        sx = circle.e === "Pass" || circle.e === "OffsidePass" || circle.e === "Goal" || circle.e === "MissedChance" || circle.e.includes("Shot") ? x(100 - circle.x_end) : x(100 - circle.x);
                        sy = circle.e === "Pass" || circle.e === "OffsidePass" || circle.e === "Goal" || circle.e === "MissedChance" || circle.e.includes("Shot") ? y(circle.y_end) : y(circle.y);
                    } else {
                        sx = circle.e === "Pass" || circle.e === "OffsidePass" || circle.e === "Goal" || circle.e === "MissedChance" || circle.e.includes("Shot") ? x(circle.x_end) : x(circle.x);
                        sy = circle.e === "Pass" || circle.e === "OffsidePass" || circle.e === "Goal" || circle.e === "MissedChance" || circle.e.includes("Shot") ? y(100 - circle.y_end) : y(100 - circle.y);
                    }
                    if (circle.o === false || circle.e === "MissedChance" || circle.e.includes("Shot") || circle.e === "OffsidePass" || circle.e === "Dispossessed")
                        this.drawCross(context, circle.isHomeTeam ? x(100 - circle.x) : x(circle.x), circle.isHomeTeam ? y(circle.y) : y(100 - circle.y), 90, '#FF0000');
                    else
                        this.drawCircle(context, circle.isHomeTeam ? x(100 - circle.x) : x(circle.x), circle.isHomeTeam ? y(circle.y) : y(100 - circle.y), circle.e === 'Pass' ? radiusPasses : radiusEvents, circle.e != 'Pass' ? 1 : 0.3, circle.e === 'Pass' ? '#FFFFFF' : '#28e628', '#28e628');
                    if (circle.e === "Pass" || circle.e === "OffsidePass" || circle.e === "Goal" || circle.e.includes("Shot")) {
                        this.drawTriangle(context, circle.isHomeTeam ? x(100 - circle.x) : x(circle.x), circle.isHomeTeam ? y(circle.y) : y(100 - circle.y), sx, sy, 45, (circle.o === false || circle.e === "MissedChance" || circle.e.includes("Shot") || circle.e === "OffsidePass" ? '#FF0000' : '#28e628'));
                    }
                } else {
                    if (circle.isHomeTeam) {
                        sx = x(100 - circle.x);
                        sy = y(circle.y);
                    } else {
                        sx = x(circle.x);
                        sy = y(100 - circle.y);
                    }
                    let colorOfcarries = this.getColorOfCarries(circle);
                    this.drawCircle(context, sx, sy, 7, circle.e === "Goal" || circle.e === "Assist" || (circle.e === "Event" && circle.o === true) ? 0.9 : 0.2, colorOfcarries, colorOfcarries);
                }
            }
        },
        renderSegments(context, segments, teamColor, widthDomain = null) {
            widthDomain = widthDomain !== null ? [0, 60] : extent(segments, c => c.width);

            let x = scaleLinear().domain([0, 100]).range([this.WIDTH, 0]);
            let y = scaleLinear().domain([0, 100]).range([this.HEIGHT, 0]);
            let width = scaleLinear().domain(widthDomain).range([1 * this.dpr * this.chartRate, 10 * this.dpr * this.chartRate]);
            let radiusScalePasses = d3.scale.linear().domain([0, 1]).range([this.chartSize * 0.0055, this.chartSize * 0.024]);
            let radiusPasses = radiusScalePasses(0.3);

            // ====================================================================
            //        Render Segments
            // ====================================================================
            for (let segment of segments) {
                let sx0 = segment.isHomeTeam ? x(100 - segment.x) : x(segment.x);
                let sy0 = segment.isHomeTeam ? y(segment.y) : y(100 - segment.y);
                let sx1 = segment.isHomeTeam ? x(100 - segment.x_end): x(segment.x_end);
                let sy1 = segment.isHomeTeam ? y(segment.y_end) : y(100 - segment.y_end);

                //Draw start of pass line on circle border instead of center of the circle
                if(segment.e === 'Pass'){
                    const angleRadians = Math.atan2(sy1 - sy0, sx1 - sx0);
                    sx0 = sx0 + Math.cos(angleRadians) * radiusPasses;
                    sy0 = sy0 + Math.sin(angleRadians) * radiusPasses;
                    sx1 = sx1 - Math.cos(angleRadians) * radiusPasses;
                    sy1 = sy1 - Math.sin(angleRadians) * radiusPasses;
                }

                if (segment.e !== "Carries" && segment.e !== "BallProgression")
                    this.drawXALine(context, sx0, sy0, sx1, sy1,
                        width(segment.width) * 1.5, segment.xA,
                        (segment.o === false || segment.e === "MissedChance" || segment.e.includes("Shot") || segment.e === "OffsidePass" ? '#FF0000' : '#28e628'), 0.8);
                else{
                    //Here code for Carries and BallProgressions
                    sx0 = segment.isHomeTeam ? x(100 - segment.pESX) : x(segment.pESX);
                    sy0 = segment.isHomeTeam ? y(segment.pESY) : y(100 - segment.pESY);
                    sx1 = segment.isHomeTeam ? x(100 - segment.x): x(segment.x);
                    sy1 = segment.isHomeTeam ? y(segment.y) : y(100 - segment.y);
                    let sx2 = segment.isHomeTeam ? x(100 - segment.x_end): x(segment.x_end);
                    let sy2 = segment.isHomeTeam ? y(segment.y_end) : y(100 - segment.y_end);

                    let colorOfCarries = this.getColorOfCarries(segment);
                    let angle = this.getAngle(sx0, sy0, sx1, sy1);
                    let sx1Carries = sx1 - Math.cos(angle) * 15;
                    let sy1Carries = sy1 - Math.sin(angle) * 15;
                    this.drawXALine(context, sx0, sy0, sx1Carries, sy1Carries, segment.result === "Event" ? width(segment.width) * 1.5 : width(segment.width) * 2, segment.xA, colorOfCarries, segment.result === "Event" ? 0.4 : 0.9);

                    if(segment.x != segment.x_end && segment.e === "BallProgression"){
                        let angle2 = this.getAngle(sx1, sy1, sx2, sy2);
                        sx1 = sx1 + Math.cos(angle2) * 15;
                        sy1 = sy1 + Math.sin(angle2) * 15;
                        //If x and x_end are different and is a BallProgression, then print next event (dashed) line
                        this.drawNextEventLine(context, sx1, sy1, sx2, sy2, segment.result === "Event" ? width(segment.width) * 1.5 : width(segment.width) * 2, segment.xA, colorOfCarries, segment.result === "Event" ? 0.4 : 0.9);
                        this.drawTriangle(context, sx1, sy1, sx2, sy2, 45, colorOfCarries);
                    }
                }
            }//end for
        },
        async drawPitch(context, canvas, imgSrc) {
            let img = new Image();
            let p = new Promise((resolve, reject) => {
                img.onload = () => {
                context.drawImage(img, 0, 0, canvas.width, canvas.height);
                resolve(img);
                };
            });
            img.src = imgSrc;
            return p;
        },
        renderBoxes(context, shots, vertical) {
            const goalArea = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x >= 94.2 && y >= 36.8 && y <= 63.2;
            }).length;
            const boxRight = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x >= 83 && y >= 21.1 && y < 36.8;
            }).length;
            const boxCenter = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return  x >= 83 && x < 94.2 && y >= 36.8 && y <= 63.2;
            }).length;
            const boxLeft = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return  x >= 83 && y > 63.2 && y < 78.9;
            }).length;

            //Out Of Box
            const outBoxDeepRight = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x >= 83 && y < 21.1;
            }).length;
            const outBoxDeepLeft = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x >= 83 && y > 78.9;
            }).length;
            const outBoxRight = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x >= 65 && x < 83 && y < 21.1;
            }).length;
            const outBoxCentreRight = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x >= 65 && x < 83 && y >= 21.1 && y <= 35.5;
            }).length;
            const outBoxCentre = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x >= 65 && x < 83 && y >= 35.6 && y <= 64.4;
            }).length;
            const outBoxCentreLeft = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x >= 65 && x < 83 && y >= 64.5 && y <= 78.9;
            }).length;
            const outBoxLeft = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x >= 65 && x < 83 && y > 78.9;
            }).length;

            //+35
            const right35 = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                if(vertical){
                return x >= 50 && x < 65 && y < 21.1;
                }else{
                return x >= 35 && x < 65 && y < 21.1;
                }
            }).length;
            const centreRight35 = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                if(vertical){
                return x >= 50 && x < 65 && y >= 21.1 && y <= 35.5;
                }else{
                return x >= 35 && x < 65 && y >= 21.1 && y <= 35.5;
                }
            }).length;
            const centre35 = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                if(vertical){
                return x >= 50 && x < 65 && y >= 35.6 && y <= 64.4;
                }else{
                return x >= 35 && x < 65 && y >= 35.6 && y <= 64.4;
                }

            }).length;
            const centreLeft35 = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                if(vertical){
                return x >= 50 && x < 65 && y >= 64.5 && y <= 78.9;
                }else{
                return x >= 35 && x < 65 && y >= 64.5 && y <= 78.9;
                }

            }).length;
            const left35 = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                if(vertical){
                return x >= 50 && x < 65 && y > 78.9;
                }else{
                return x >= 35 && x < 65 && y > 78.9;
                }

            }).length;

            //Own Half
            const ownFieldOutOfBoxRight = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x < 35 && x > 17 && y < 21.1;
            }).length;
            const ownFieldOutOfBoxCentreRight = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x < 35 && x > 17 && y >= 21.1 && y <= 35.5;
            }).length;
            const ownFieldOutOfBoxCentre = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x < 35 && x > 17 && y >= 35.6 && y <= 64.4;
            }).length;
            const ownFieldOutOfBoxCentreLeft = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x < 35 && x > 17 && y >= 64.5 && y <= 78.9;
            }).length;
            const ownFieldOutOfBoxLeft = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x < 35 && x > 17 && y > 78.9;
            }).length;

            const ownFieldOutOfBoxDeepLeft = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x <= 17 && y > 78.9;
            }).length;
            const ownFieldOutOfBoxDeepRight = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x <= 17 && y < 21.1;
            }).length;
            const ownGoalArea = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x <= 5.8 && y >= 36.8 && y <= 63.2;
            }).length;
            const ownBoxRight = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x <= 17 && y >= 21.1 && y < 36.8;
            }).length;
            const ownBoxCentre = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x > 5.8 && x <= 17 && y >= 36.8 && y <= 63.2;
            }).length;
            const ownBoxLeft = shots.filter(s => {
                let x = (s.e === "Carries" || s.e === "BallProgression") ? s.pESX : s.x;
                let y = (s.e === "Carries" || s.e === "BallProgression") ? s.pESY : s.y;
                return x <= 17 && y > 63.2 && y < 78.9;
            }).length;

            if (vertical) {
                // LEFT
                if (outBoxDeepLeft > 0.5)
                this.renderBox(context, outBoxDeepLeft, shots, 0.094, 0.105, 0.155, 0.25, 0.177, 0.23);
                if (outBoxLeft > 0.5)
                this.renderBox(context, outBoxLeft, shots, 0.094, 0.365, 0.155, 0.295, 0.177, 0.49);
                if (left35 > 0.5)
                this.renderBox(context, left35, shots, 0.094, 0.665, 0.155, 0.24, 0.177, 0.765);
                // RIGHT
                if (outBoxDeepRight > 0.5)
                this.renderBox(context, outBoxDeepRight, shots, 0.76, 0.105, 0.155, 0.25, 0.842, 0.23);
                if (outBoxRight > 0.5)
                this.renderBox(context, outBoxRight, shots, 0.76, 0.365, 0.155, 0.295, 0.842, 0.49);
                if (right35 > 0.5)
                this.renderBox(context, right35, shots, 0.76, 0.665, 0.155, 0.24, 0.842, 0.765);
                // Center outside area
                if (outBoxCentreLeft > 0.5)
                this.renderBox(context, outBoxCentreLeft, shots, 0.254, 0.365, 0.13, 0.295, 0.33, 0.49);
                if (outBoxCentre > 0.5)
                this.renderBox(context, outBoxCentre, shots, 0.39, 0.365, 0.23, 0.295, 0.505, 0.49);
                if (outBoxCentreRight > 0.5)
                this.renderBox(context, outBoxCentreRight, shots, 0.625, 0.365, 0.13, 0.295, 0.69, 0.49);
                //Centre +35 meters
                if (centreLeft35 > 0.5)
                this.renderBox(context, centreLeft35, shots, 0.254, 0.665, 0.13, 0.24, 0.33, 0.765);
                if (centre35 > 0.5)
                this.renderBox(context, centre35, shots, 0.39, 0.665, 0.23, 0.24, 0.505, 0.765);
                if (centreRight35 > 0.5)
                this.renderBox(context, centreRight35, shots, 0.625, 0.665, 0.13, 0.24, 0.69, 0.765);
                // Inside area
                if (boxLeft  > 0.5)
                this.renderBox(context, boxLeft, shots, 0.265, 0.105, 0.12, 0.24, 0.33, 0.23);
                if (boxRight > 0.5)
                this.renderBox(context, boxRight, shots, 0.625, 0.105, 0.12, 0.24, 0.69, 0.23);
                // Small area
                if (goalArea > 0.5)
                this.renderBox(context, goalArea, shots, 0.4, 0.105, 0.21, 0.068, 0.505, 0.15);
                // Penalty
                if (boxCenter > 0.5)
                this.renderBox(context, boxCenter, shots, 0.39, 0.19, 0.23, 0.155, 0.505, 0.25);
            } else {
                // Goal Area
                if (goalArea > 0.5)
                this.renderBox(context, goalArea, shots, 0.867, 0.432, 0.042, 0.2, 0.89, 0.54);
                if (boxLeft > 0.5)
                this.renderBox(context, boxLeft, shots, 0.78, 0.32, 0.13, 0.107, 0.85, 0.38);
                if (boxCenter > 0.5)
                this.renderBox(context, boxCenter, shots, 0.78, 0.432, 0.08, 0.2, 0.825, 0.54);
                if (boxRight > 0.5)
                this.renderBox(context, boxRight, shots, 0.78, 0.64, 0.13, 0.11, 0.85, 0.71);
                // LEFT
                if (outBoxDeepLeft > 0.5)
                this.renderBox(context, outBoxDeepLeft, shots, 0.78, 0.16, 0.13, 0.15, 0.85, 0.24);
                if (outBoxLeft > 0.5)
                this.renderBox(context, outBoxLeft, shots, 0.63, 0.16, 0.14, 0.15, 0.7, 0.24);
                if (left35 > 0.5)
                this.renderBox(context, left35, shots, 0.38, 0.16, 0.245, 0.15, 0.5, 0.24);
                // RIGHT
                if (outBoxDeepRight > 0.5)
                this.renderBox(context, outBoxDeepRight, shots, 0.78, 0.763, 0.13, 0.15, 0.85, 0.85);
                if (outBoxRight > 0.5)
                this.renderBox(context, outBoxRight, shots, 0.63, 0.763, 0.14, 0.15, 0.7, 0.85);
                if (right35 > 0.5)
                this.renderBox(context, right35, shots, 0.38, 0.763, 0.245, 0.15, 0.5, 0.85);
                // Center outside area
                if (outBoxCentreLeft > 0.5)
                this.renderBox(context, outBoxCentreLeft, shots, 0.63, 0.32, 0.14, 0.107, 0.7, 0.38);
                if (outBoxCentre > 0.5)
                this.renderBox(context, outBoxCentre, shots, 0.63, 0.432, 0.14, 0.2, 0.7, 0.54);
                if (outBoxCentreRight > 0.5)
                this.renderBox(context, outBoxCentreRight, shots, 0.63, 0.64, 0.14, 0.11, 0.7, 0.71);
                // Center midfield area
                if (centreLeft35 > 0.5)
                this.renderBox(context, centreLeft35, shots, 0.38, 0.32, 0.245, 0.107, 0.5, 0.38);
                if (centre35 > 0.5)
                this.renderBox(context, centre35, shots, 0.38, 0.432, 0.245, 0.2, 0.5, 0.54);
                if (centreRight35 > 0.5)
                this.renderBox(context, centreRight35, shots, 0.38, 0.64, 0.245, 0.11, 0.5, 0.71);
                // Own Field Out of Box
                if (ownFieldOutOfBoxLeft > 0.5)
                this.renderBox(context, ownFieldOutOfBoxLeft, shots, 0.23, 0.16, 0.147, 0.15, 0.3, 0.24);
                if (ownFieldOutOfBoxCentreLeft > 0.5)
                this.renderBox(context, ownFieldOutOfBoxCentreLeft, shots, 0.23, 0.32, 0.147, 0.107, 0.3, 0.38);
                if (ownFieldOutOfBoxCentre > 0.5)
                this.renderBox(context, ownFieldOutOfBoxCentre, shots, 0.23, 0.432, 0.147, 0.2, 0.3, 0.54);
                if (ownFieldOutOfBoxCentreRight > 0.5)
                this.renderBox(context, ownFieldOutOfBoxCentreRight, shots, 0.23, 0.64, 0.147, 0.11, 0.3, 0.71);
                if (ownFieldOutOfBoxRight > 0.5)
                this.renderBox(context, ownFieldOutOfBoxRight, shots, 0.23, 0.763, 0.147, 0.15, 0.3, 0.85);
                // Deep ends
                if (ownFieldOutOfBoxDeepLeft > 0.5)
                this.renderBox(context, ownFieldOutOfBoxDeepLeft, shots, 0.09, 0.16, 0.127, 0.15, 0.16, 0.24);
                if (ownFieldOutOfBoxDeepRight > 0.5)
                this.renderBox(context, ownFieldOutOfBoxDeepRight, shots, 0.09, 0.763, 0.127, 0.15, 0.16, 0.85);
                // Own Goal Area
                if (ownGoalArea > 0.5)
                this.renderBox(context, ownGoalArea, shots, 0.09, 0.437, 0.035, 0.19, 0.11, 0.54);
                if (ownBoxLeft > 0.5)
                this.renderBox(context, ownBoxLeft, shots, 0.09, 0.32, 0.127, 0.107, 0.16, 0.38);
                if (ownBoxCentre > 0.5)
                this.renderBox(context, ownBoxCentre, shots, 0.14, 0.432, 0.077, 0.2, 0.175, 0.54);
                if (ownBoxRight > 0.5)
                this.renderBox(context, ownBoxRight, shots, 0.09, 0.64, 0.127, 0.11, 0.16, 0.71);
            }
        },
        renderBox(context, boxShots, totalShots, rectX1, rectY1, rectX2, rectY2, textX, textY) {
            var shadowScale = scaleLinear().domain([0, totalShots.length]).range([0.1, 0.7]);
            context.fillStyle = "rgba(255,0,0, " + shadowScale(boxShots) + ")";
            //  - this.margins.left- this.margins.top
            context.beginPath();
            context.rect((rectX1 * this.CANVASWIDTH), (rectY1 * this.CANVASHEIGHT), rectX2 * this.CANVASWIDTH , rectY2 * this.CANVASHEIGHT);
            context.fill();
            context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' : "rgba(255,255,255, 0.85)";
            context.textAlign = "center";
            context.font = `bold ${26 * this.dpr * this.chartRate}px ${this.labelFamily}`;
            context.fillText(Math.round(boxShots / totalShots.length * 100) + "%",  (textX * this.CANVASWIDTH), (textY * this.CANVASHEIGHT));
        },
        renderLegend(context, eventLegend, passLegend, carryLegend, ballProgressionLegend) {
            let x = scaleLinear().domain([0, 100]).range([this.WIDTH, 0]);
            let y = scaleLinear().domain([0, 100]).range([this.HEIGHT, 0]);
            let radiusScalePasses = d3.scale.linear().domain([0, 1]).range([this.chartSize * 0.0055, this.chartSize * 0.024]);
            let radiusPasses = radiusScalePasses(0.02);
            let radiusEvents = radiusScalePasses(0.125);

            let offset = 0;
            let fontSize = 15;
            let baseY = 0.945 * this.CANVASHEIGHT;
            let yOffset = 0.032 * this.CANVASHEIGHT;
            let yOffsetMini = 0.004 * this.CANVASHEIGHT;
            if (eventLegend) {
                this.drawCircle(context, x(89), baseY, radiusEvents, 1, '#28e628', '#28e628');
                this.drawCross(context, x(89), baseY + yOffset, 140, '#FF0000');

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;

                context.fillText(this.$t("eventChart.successfulEvent"), x(87.5), baseY + yOffsetMini);
                context.fillText(this.$t("eventChart.unsuccessfulEvent"), x(87.5), baseY + yOffset + yOffsetMini);

                offset = 19;
            }

            if (passLegend) {
                this.drawCircle(context, x(89 - offset), baseY, radiusPasses, 0.2, '#28e628', '#28e628');
                this.drawCross(context, x(89 - offset), baseY + yOffset, 90, '#FF0000');
                this.drawXALine(context, x(88.2 - offset), baseY, x(85.8 - offset), baseY, 2, 1, '#28e628');
                this.drawXALine(context, x(88.8 - offset), baseY + yOffset, x(85.8 - offset), baseY + yOffset, 2, 1, '#FF0000');
                this.drawTriangle(context, x(89 - offset), baseY, x(85.8 - offset), baseY, 45, '#28e628');
                this.drawTriangle(context, x(89 - offset), baseY + yOffset, x(85.8 - offset), baseY + yOffset, 45, '#FF0000');

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;
                context.fillText(this.$t("eventChart.successfulPass"),x(84.5 - offset), baseY + yOffsetMini );
                context.fillText(this.$t("eventChart.unsuccessfulPass"), x(84.5 - offset), baseY + yOffset + yOffsetMini);
                offset += 19;
            }
            //Legend for Carries
            if (carryLegend && !ballProgressionLegend) {
                this.drawXALine(context, x(90 - offset), baseY, x(87.8 - offset), baseY, 2, 1, '#b3b7c6');
                this.drawXALine(context, x(90 - offset), baseY + yOffset, x(87.8 - offset), baseY + yOffset, 2, 1, '#b3b7c6');
                this.drawCircle(context, x(87 - offset), baseY, 6, 0.9, '#b3b7c6', '#b3b7c6');
                this.drawCircle(context, x(87 - offset), baseY + yOffset, 6, 0.2, '#b3b7c6', '#b3b7c6');

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;
                let successfulText = this.$t("eventChart.successfulCarry");
                let unsuccessfulText = this.$t("eventChart.unsuccessfulCarry");
                context.fillText(successfulText, x(85.5 - offset), baseY + yOffsetMini);
                context.fillText(unsuccessfulText, x(85.5 - offset), baseY + yOffset + yOffsetMini);

                this.drawXALine(context, x(68 - offset), baseY, x(65.8 - offset), baseY, 2, 1, '#1e1eff');
                this.drawXALine(context, x(68 - offset), baseY + yOffset, x(65.8 - offset), baseY + yOffset, 2, 1, '#1e1eff');
                this.drawCircle(context, x(65 - offset), baseY, 6, 0.2, '#1e1eff', '#1e1eff');
                this.drawCircle(context, x(65 - offset), baseY + yOffset, 6, 0.9, '#1e1eff', '#1e1eff');

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;

                let keyPassText = this.$t("eventChart.carryAndKeyPass");
                let assistText = this.$t("eventChart.carryAndAssist");
                context.fillText(keyPassText, x(63.5 - offset), baseY + yOffsetMini);
                context.fillText(assistText, x(63.5 - offset), baseY + yOffset + yOffsetMini);

                //Update offset
                offset += 3;
                this.drawXALine(context, x(50 - offset), baseY, x(47.8 - offset), baseY, 2, 1, '#28e628');
                this.drawXALine(context, x(50 - offset), baseY + yOffset, x(47.8 - offset), baseY + yOffset, 2, 1, '#28e628');
                this.drawCircle(context, x(47 - offset), baseY, 6, 0.2, '#28e628', '#28e628');
                this.drawCircle(context, x(47 - offset), baseY + yOffset, 6, 0.9, '#28e628', '#28e628');

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;

                let shotText = this.$t("eventChart.carryAndShot");
                let goalText = this.$t("eventChart.carryAndShot");

                context.fillText(shotText, x(45.5 - offset), baseY + yOffsetMini);
                context.fillText(goalText, x(45.5 - offset), baseY + yOffset + yOffsetMini);
            }

            //Legend for Ball Progressions
            if(ballProgressionLegend && !carryLegend){
                // -------- Gray Legend -----------
                this.drawXALine(context, x(90 - offset), baseY, x(87.8 - offset), baseY, 2, 1, '#b3b7c6');
                this.drawXALine(context, x(90 - offset), baseY + yOffset, x(87.8 - offset), baseY + yOffset, 2, 1, '#b3b7c6');
                this.drawCircle(context, x(87 - offset), baseY, 6, 0.9, '#b3b7c6', '#b3b7c6');
                this.drawCircle(context, x(87 - offset), baseY + yOffset, 6, 0.9, '#b3b7c6', '#b3b7c6');
                this.drawNextEventLine(context, x(86 - offset), baseY, x(83.8 - offset), baseY, 2, 1, '#b3b7c6');
                this.drawTriangle(context, x(86 - offset), baseY, x(83.8 - offset), baseY, 45, '#b3b7c6');

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;
                let ballProgressionAndPassText = this.$t("eventChart.ballProgressionAndPass");
                let ballProgressionText = this.$t("eventChart.ballProgression");
                context.fillText(ballProgressionAndPassText, x(82.3 - offset), baseY + yOffsetMini);
                context.fillText(ballProgressionText, x(85.5 - offset), baseY + yOffset + yOffsetMini);

                // -------- Blue Legend -----------
                //Update offset
                offset += 3;

                this.drawXALine(context, x(68 - offset), baseY, x(65.8 - offset), baseY, 2, 1, '#1e1eff');
                this.drawCircle(context, x(65 - offset), baseY, 6, 0.2, '#1e1eff', '#1e1eff');
                this.drawNextEventLine(context, x(64 - offset), baseY, x(61.8 - offset), baseY, 2, 1, '#1e1eff');
                this.drawTriangle(context, x(64 - offset), baseY, x(61.8 - offset), baseY, 45, '#1e1eff');

                this.drawXALine(context, x(68 - offset), baseY + yOffset, x(65.8 - offset), baseY + yOffset, 2, 1, '#1e1eff');
                this.drawCircle(context, x(65 - offset), baseY + yOffset, 6, 0.9, '#1e1eff', '#1e1eff');
                this.drawNextEventLine(context, x(64 - offset), baseY + yOffset, x(61.8 - offset), baseY + yOffset, 2, 1, '#1e1eff');
                this.drawTriangle(context, x(64 - offset), baseY + yOffset, x(61.8 - offset), baseY + yOffset, 45, '#1e1eff');

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;

                let keyPassText = this.$t("eventChart.ballProgressionAndKeyPass");
                let assistText = this.$t("eventChart.ballProgressionAndAssist");
                context.fillText(keyPassText, x(60.3 - offset), baseY + yOffsetMini);
                context.fillText(assistText, x(60.3 - offset), baseY + yOffset + yOffsetMini);

                //Update offset
                offset += 2;
                // -------- Green Legend -----------
                this.drawXALine(context, x(43 - offset), baseY, x(40.8 - offset), baseY, 2, 1, '#28e628');
                this.drawXALine(context, x(43 - offset), baseY + yOffset, x(40.8 - offset), baseY + yOffset, 2, 1, '#28e628');
                this.drawCircle(context, x(40 - offset), baseY, 6, 0.2, '#28e628', '#28e628');
                this.drawCircle(context, x(40 - offset), baseY + yOffset, 6, 0.9, '#28e628', '#28e628');

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;

                let shotText = this.$t("eventChart.ballProgressionAndShot");
                let goalText = this.$t("eventChart.ballProgressionAndGoal");

                context.fillText(shotText, x(38.5 - offset), baseY + yOffsetMini);
                context.fillText(goalText, x(38.5 - offset), baseY + yOffset + yOffsetMini);
            }

            //Legend for Ball Progressions and Carries
            if(ballProgressionLegend && carryLegend){
                // ------------ Gray Legend -----------
                //Successful Carry
                this.drawXALine(context, x(90 - offset), baseY, x(87.8 - offset), baseY, 2, 1, '#b3b7c6');
                this.drawXALine(context, x(90 - offset), baseY + yOffset, x(87.8 - offset), baseY + yOffset, 2, 1, '#b3b7c6');
                let successfulText = this.$t("eventChart.successfulCarry");

                //Unsuccessfull Carry
                this.drawCircle(context, x(87 - offset), baseY, 6, 0.9, '#b3b7c6', '#b3b7c6');
                this.drawCircle(context, x(87 - offset), baseY + yOffset, 6, 0.2, '#b3b7c6', '#b3b7c6');
                let unsuccessfulText = this.$t("eventChart.unsuccessfulCarry");

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;
                context.fillText(successfulText, x(85.5 - offset), baseY + yOffsetMini);
                context.fillText(unsuccessfulText, x(85.5 - offset), baseY + yOffset + yOffsetMini);

                //Pass
                this.drawCircle(context, x(67 - offset), baseY, 6, 0.9, '#b3b7c6', '#b3b7c6');
                this.drawNextEventLine(context, x(66 - offset), baseY, x(63.8 - offset), baseY, 2, 1, '#b3b7c6');
                this.drawTriangle(context, x(66 - offset), baseY, x(63.8 - offset), baseY, 45, '#b3b7c6');

                //Carry & Pass
                this.drawXALine(context, x(70 - offset), baseY + yOffset, x(67.8 - offset), baseY + yOffset, 2, 1, '#b3b7c6');
                this.drawCircle(context, x(67 - offset), baseY + yOffset, 6, 0.9, '#b3b7c6', '#b3b7c6');
                this.drawNextEventLine(context, x(66 - offset), baseY + yOffset, x(63.8 - offset), baseY + yOffset, 2, 1, '#b3b7c6');
                this.drawTriangle(context, x(66 - offset), baseY + yOffset, x(63.8 - offset), baseY + yOffset, 45, '#b3b7c6');

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;

                let ballProgressionAndPassText = this.$t("eventChart.pass");
                context.fillText(ballProgressionAndPassText, x(62.5 - offset), baseY + yOffsetMini);
                let carryAndBallProgressionAndPassText = this.$t("eventChart.carryAndPass");
                context.fillText(carryAndBallProgressionAndPassText, x(62.5 - offset), baseY + yOffset + yOffsetMini);

                // -------- Blue Legend -----------
                //Carry & Key Pass
                this.drawXALine(context, x(51 - offset), baseY, x(48.8 - offset), baseY, 2, 1, '#1e1eff');
                this.drawCircle(context, x(48 - offset), baseY, 6, 0.2, '#1e1eff', '#1e1eff');
                this.drawNextEventLine(context, x(47 - offset), baseY, x(44.8 - offset), baseY, 2, 1, '#1e1eff');
                this.drawTriangle(context, x(47 - offset), baseY, x(44.8 - offset), baseY, 45, '#1e1eff');
                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;

                let carryAndBPkeyPassText = this.$t("eventChart.carryAndKeyPass");
                context.fillText(carryAndBPkeyPassText, x(43.5 - offset), baseY + yOffsetMini);
                //Carry & Assist
                this.drawXALine(context, x(51 - offset), baseY + yOffset, x(48.8 - offset), baseY + yOffset, 2, 1, '#1e1eff');
                this.drawCircle(context, x(48 - offset), baseY + yOffset, 6, 0.9, '#1e1eff', '#1e1eff');
                this.drawNextEventLine(context, x(47 - offset), baseY + yOffset, x(44.8 - offset), baseY + yOffset, 2, 1, '#1e1eff');
                this.drawTriangle(context, x(47 - offset), baseY + yOffset, x(44.8 - offset), baseY + yOffset, 45, '#1e1eff');
                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;

                let carryAndBPAssistText =  this.$t("eventChart.carryAndAssist");
                context.fillText(carryAndBPAssistText, x(43.5 - offset), baseY + yOffset + yOffsetMini);

                // -------- Green Legend -----------
                offset += 1;
                this.drawXALine(context, x(28 - offset), baseY, x(25.8 - offset), baseY, 2, 1, '#28e628');
                this.drawXALine(context, x(28 - offset), baseY + yOffset, x(25.8 - offset), baseY + yOffset, 2, 1, '#28e628');
                this.drawCircle(context, x(25 - offset), baseY, 6, 0.2, '#28e628', '#28e628');
                this.drawCircle(context, x(25 - offset), baseY + yOffset, 6, 0.9, '#28e628', '#28e628');

                context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
                context.textAlign = "left";
                context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;

                let shotText = this.$t("eventChart.carryAndShot");
                let goalText = this.$t("eventChart.carryAndGoal");

                context.fillText(shotText, x(23.5 - offset), baseY + yOffsetMini);
                context.fillText(goalText, x(23.5 - offset), baseY + yOffset + yOffsetMini);
            }
        },
        renderDirectionOfPlay(context){
            let img = new Image();
            img.onload = () => {
                context.drawImage(img, 0.7275 * this.CANVASWIDTH, 0.915 * this.CANVASHEIGHT,
                    0.075 * 4 * this.CANVASHEIGHT, 0.075 * this.CANVASHEIGHT);
            };
            img.src = this.currentUserLanguage === 'es' ?
            require(`@/assets/img/attack_spanish${this.currentUserFieldColor === 'white' ? '_dark' : ''}.png`) :
            require(`@/assets/img/attack_english${this.currentUserFieldColor === 'white' ? '_dark' : ''}.png`);
        },
        renderLogo(context){
            let img = new Image();
            img.onload = () => {
                const scale = 0.5; // Adjust this value to make the image smaller (e.g., 0.5 for 50% size)
                const originalAspectRatio = 1000 / 200; // Aspect ratio of 5:1

                const drawHeight = scale * 0.09 * this.CANVASHEIGHT; // Scaled height
                const drawWidth = drawHeight * originalAspectRatio; // Scaled width based on aspect ratio

                context.drawImage(
                    img,
                    0.755 * this.CANVASWIDTH, // X position
                    0.8525 * this.CANVASHEIGHT, // Y position
                    drawWidth, // New scaled width
                    drawHeight // New scaled height
                );
            };
            img.src = require(`@/assets/img/driblab_${this.currentUserFieldColor === 'white' ? 'color' :"white"}.png`);
        },
        renderPlayerPrompt(context,playerName){
            let eventsText = "";
            let successfulEventsNumber = this.events.filter(e => e.o === true).length;
            eventsText = this.events.length + " " + this.$t("eventChart.totalTouches") + (successfulEventsNumber === this.events.length ? "" : " (" + successfulEventsNumber + " " + this.$t("eventChart.successful") + ")");

            context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
            context.textAlign = "left";
            context.font = `bold ${20 * this.dpr * this.chartRate}px ${this.labelFamily}`;

            context.fillText(`${playerName}`, 0.085 * this.CANVASWIDTH, 50 * this.dpr * this.chartRate);

            context.textAlign = "right"
            context.fillText(`${eventsText}`,0.9175 * this.CANVASWIDTH , 50 * this.dpr * this.chartRate)

            context.textAlign = "right";
            context.font = `bold ${15 * this.dpr * this.chartRate}px ${this.labelFamily}`;
        },
        handleMouseEnter(canvas, voronoiDiagram, divSelection, onClick) {
            canvas.addEventListener('click', (event) => {
                const scrollTop = window.scrollY;
                const scrollLeft = window.scrollX;
                // const scrollTop = 0;
                // const scrollLeft = 0;

                // let x = event.pageX - canvas.offsetLeft - (this.margins.left / this.dpr) + scrollLeft;
                // let y = event.pageY - canvas.offsetTop - (this.margins.top / this.dpr);
                let x = event.offsetX - (this.margins.left / this.dpr) + scrollLeft;
                let y = event.offsetY - (this.margins.top / this.dpr);
                let site = voronoiDiagram.find(x * this.dpr, y * this.dpr, 9 * this.dpr);

                if (site) {
                    let tooltipX = this.$vuetify.breakpoint.mobile && !this.embed ? (this.WIDTH * 0.13) - (this.margins.left / this.dpr) + scrollLeft : event.pageX + scrollLeft;
                    let tooltipY = this.$vuetify.breakpoint.mobile && !this.embed ? (this.HEIGHT * 0.16) + (this.margins.top / this.dpr) + canvas.offsetTop : event.pageY;
                    divSelection.transition()
                        .duration(200)
                        .style("opacity", 0.98);
                    divSelection.html("<strong>" +site.data.player + "</strong></br><strong>" + site.data.game + "</strong></br>" + (site.data.eventLabel ? site.data.eventLabel : site.data.e) + " <small>@</small> " + site.data.min + ":" + site.data.sec + "</br><small style='display:block;margin-top: -4px'>" + this.$t(`eventChart.${site.data.o ? 'successful' : 'unsuccessful'}`) + "</small>")
                        .style("left", (tooltipX) + "px")
                        .style("top", (tooltipY) + "px")
                        .style("padding","10px 40px")
                } else {
                    divSelection.transition()
                        .duration(500)
                        .style("opacity", 0);
                }
            });
        },
        computeVoronoi(circles, type) {
            let x = scaleLinear().domain([0, 100]).range([this.WIDTH, 0]);
            let y = scaleLinear().domain([0, 100]).range([this.HEIGHT, 0]);

            if (type === 'fullPitch') {
                let v = voronoi()
                    .x( circle => circle.xG ? (circle.isHomeTeam ? x(circle.x) : x(100 - circle.x)) : x(100 - circle.x))
                    .y( circle => circle.xG ? (circle.isHomeTeam ? y(100 - circle.y) : y(circle.y)) : y(circle.y))
                (circles);
                return v;
            } else if (type === 'fullPitchEndPasses') {
                let v = voronoi()
                    .x( circle => circle.xG ? (circle.isHomeTeam ? x(circle.x_end) : x(100 - circle.x_end)) : x(100 - circle.x_end))
                    .y( circle => circle.xG ? (circle.isHomeTeam ? y(100 - circle.y_end) : y(circle.y_end)) : y(circle.y_end))
                (circles);
                return v;
            } else if (type === 'verticalPitch') {
                let v = voronoi()
                    .x( circle => x(circle.y))
                    .y( circle => y(100 - (100 - circle.x) * 2))
                (circles);
                return v;
            } else if (type === 'verticalPitchEndPasses') {
                let v = voronoi()
                    .x( circle => x(circle.y_end))
                    .y( circle => y(100 - (100 - circle.x_end) * 2))
                (circles);
                return v;
            }
        },
        onResize(){
            let elto =document.getElementById(this.rootElementId);
            if(elto){
                this.$emit("sizeChange", {height:elto.clientHeight,width:elto.clientWidth});
            }
        },
        async renderHeatMap(){
            var canvasHeat = simpleheat(this.canvasElementId,this.rootElementId,this.size);
            canvasHeat.clearCanvas();
            var heat = canvasHeat.data(this.events.map(e => {
                let size = this.size > 1140 ? 1140 : this.size;
                let zoom = window.devicePixelRatio < 1 ? window.devicePixelRatio : 1 ;
                e.xHeatMap = (e.x * (0.0083 * size * 1)) + (0.0854 * size * 1);
                e.yHeatMap = ((100 - e.y) * (0.0055 * size * 1)) + (0.0595 * size * 1);
                return [e.xHeatMap,e.yHeatMap,0.95]
            })).max(1);

            let context = document.getElementById(this.canvasElementId).getContext("2d");
            this.renderLogoHeatMap(context);

            heat.radius(45 / 2);
            heat.draw(50 / 100);

            this.renderDirectionOfPlayHeatMap(context);


            if(this.events && this.events.length){
                this.renderPlayerPromptHeatMap(context,this.events[0].player)
            }
        },
        renderPlayerPromptHeatMap(context,playerName){
            let eventsText = "";
            let successfulEventsNumber = this.events.filter(e => e.o === true).length;
            eventsText = this.events.length + " " + this.$t("eventChart.totalTouches") + (successfulEventsNumber === this.events.length ? "" : " (" + successfulEventsNumber + " " + this.$t("eventChart.successful") + ")");

            context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' : "white";
            context.textAlign = "left";
            context.font = `bold ${10 * this.dpr * this.chartRate}px ${this.labelFamily}`;

            context.fillText(`${playerName}`, 0.045 * this.CANVASWIDTH, 27 * this.dpr * this.chartRate);


            context.textAlign = "right";
            context.fillText(`${eventsText}`,0.4581 * this.CANVASWIDTH , 27 * this.dpr * this.chartRate)

            context.textAlign = "right";
            context.font = `bold ${15 * this.dpr * this.chartRate}px ${this.labelFamily}`;
        },
        renderDirectionOfPlayHeatMap(context){
            let img = new Image();
            img.onload = () => {
                context.drawImage(img, 0.3125 * this.CANVASWIDTH, 0.4525 * this.CANVASHEIGHT,
                    0.055 * 4 * this.CANVASHEIGHT, 0.055 * this.CANVASHEIGHT);
            };
            img.src = this.currentUserLanguage === 'es' ?
            require(`@/assets/img/attack_spanish${this.currentUserFieldColor === 'white' ? '_dark' : ''}.png`) :
            require(`@/assets/img/attack_english${this.currentUserFieldColor === 'white' ? '_dark' : ''}.png`);
        },
        renderLogoHeatMap(context){
            let img = new Image();
            img.onload = () => {
                const scale = 0.28; // Adjust this value to make the image smaller (e.g., 0.5 for 50% size)
                const originalAspectRatio = 1000 / 200; // Aspect ratio of 5:1

                const drawHeight = scale * 0.09 * this.CANVASHEIGHT; // Scaled height
                const drawWidth = drawHeight * originalAspectRatio; // Scaled width based on aspect ratio

                context.drawImage(
                    img,
                    0.370 * this.CANVASWIDTH, // X position
                    0.426 * this.CANVASHEIGHT, // Y position
                    drawWidth, // New scaled width
                    drawHeight // New scaled height
                );
            };
            img.src = require(`@/assets/img/driblab_${this.currentUserFieldColor === 'white' ? 'color' :"white"}.png`);
        },
        renderStats(context){
            let fontSize = 16;
            context.fillStyle = this.currentUserFieldColor === 'white' ? 'black' :"white";
            context.textAlign = "left";
            context.font = `bold ${fontSize * this.dpr * this.chartRate}px ${this.labelFamily}`;

            let statsPerRow = Math.ceil(this.STATS_TO_SHOW.length/2)
            let sizePerStat = (this.WIDTH * 1.075) / statsPerRow;
            // let baseX = this.CANVASWIDTH * 0.55 * 0.05;
            let baseX = this.WIDTH * 0.1;
            let baseY = this.HEIGHT * 0.135;
            for(let i = 0; i < this.STATS_TO_SHOW.length; i++){
                let stat = this.STATS_TO_SHOW[i];
                let yOffset = i < statsPerRow ? 0 : this.HEIGHT * 0.035;
                let positionInRow = i < statsPerRow ? i : i % statsPerRow;
                let statValue = Number(this.stats[stat.statCode].toFixed(2));
                let statDetailedValue = stat.isDetailed ? Number(this.stats[stat.statDetailCode].toFixed(2)) : 0;
                let statDivided = statValue ? statDetailedValue/statValue : 0;
                let text = stat.isDetailed ?
                    `${statDetailedValue}/${statValue} ${stat.text} (${(statDivided * 100).toFixed(1)}%)` :
                    `${statValue} ${stat.text}`
                context.fillText(text,baseX + (sizePerStat * positionInRow), baseY + yOffset)
            }
        }
    },

    destroyed(){
        delete this.observer;
        d3.select(`.tooltip-no-arrow`).remove();
        window.removeEventListener("resize",this.onWindowResize);
    }
  }
</script>

<style lang="scss">
    .canvas_heat_map {
        &.green_pitch{
            background:url('~@/assets/img/pitch_green.png');
            background-size: 100%;
        }
        &.blue_pitch{
            background:url('~@/assets/img/pitch_blue.png');
            background-size: 100%;
        }
        &.black_pitch{
            background:url('~@/assets/img/pitch_black.png');
            background-size: 100%;
        }
        &.white_pitch{
            background:url('~@/assets/img/pitch_white.png');
            background-size: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/base/EventsChart.vue